/**
 * Core constants for the 3-Topf vs. 1-Topf Portfolio Monte-Carlo Simulation application
 * Contains only essential configuration values and navigation
 */

// Navigation-Tabs
export const NAVIGATION_TABS = [
  {
    id: 'schritt0',
    label: 'Schritt 0: Info und FAQ',
    pfad: '/schritt0',
  },
  {
    id: 'schritt1',
    label: 'Schritt 1: Individuelle-Parameter',
    pfad: '/schritt1',
  },
  {
    id: 'schritt2',
    label: 'Schritt 2: Simulations-Parameter',
    pfad: '/schritt2',
  },
  {
    id: 'schritt3',
    label: 'Schritt 3: Einzel-Simulation',
    pfad: '/schritt3',
  },
  {
    id: 'schritt4',
    label: 'Schritt 4: Monte-Carlo-Simulation',
    pfad: '/schritt4',
  },
];

/** Footer / legal (wie Portfolio Wizard) */
export const IMPRESSUM_URL = 'https://www.svenesis.org/contact/contact_de.html';
export const DATENSCHUTZ_URL = 'https://www.svenesis.org/privacy/privacy_de.html';

/** Buy me a coffee (offizieller Button in der Kopfzeile, slug für button-api) */
export const BUY_ME_A_COFFEE_SLUG = 'sramuschkat';
export const BUY_ME_A_COFFEE_URL = `https://www.buymeacoffee.com/${BUY_ME_A_COFFEE_SLUG}`;
export const BUY_ME_A_COFFEE_TOOLTIP =
  'Kleine freiwillige Aufmerksamkeitsgeste an den Entwickler über eine externe Spendenplattform – der Button-Name ist symbolisch, es geht nicht um einen echten Kauf von Kaffee.';
